import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { useSearchPageContext } from "@/search/Langston/SearchPageProvider";
import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";

const ARTICLE_PARAM_VALUE = "ARTICLE";
const INTERACTIVE_VIDEO_PARAM_VALUE = "INTERACTIVE_VIDEO";

export const useContentSettings = () => {
  const {
    handlers: { appendSearchParam, hasSearchParamValue, setSearchParamValue },
  } = useSearchPageContext();
  const { contentSettingsToggleEnabled } = useAdminContentSettingsContext();

  const {
    activeEssentialsLicense,
    activeELALicense,
    activeSSLicense,
    activeScienceLicense,
  } = useGetUserProperties();

  const isOnlyActiveEssentialsLicense =
    activeEssentialsLicense &&
    !activeELALicense &&
    !activeSSLicense &&
    !activeScienceLicense;

  const invokeContentSettingsSearchModeChange = () => {
    if (!contentSettingsToggleEnabled) {
      // the Content Settings mode was deactivated, but the change activated it...insert the following query params
      if (isOnlyActiveEssentialsLicense) {
        setSearchParamValue(
          LangstonParameterSchema.content_types.key,
          ARTICLE_PARAM_VALUE,
        );
      } else {
        !hasSearchParamValue(
          LangstonParameterSchema.content_types.key,
          ARTICLE_PARAM_VALUE,
        ) &&
          appendSearchParam(
            LangstonParameterSchema.content_types.key,
            ARTICLE_PARAM_VALUE,
          );
        !hasSearchParamValue(
          LangstonParameterSchema.content_types.key,
          INTERACTIVE_VIDEO_PARAM_VALUE,
        ) &&
          appendSearchParam(
            LangstonParameterSchema.content_types.key,
            INTERACTIVE_VIDEO_PARAM_VALUE,
          );
      }
    }
  };

  return { invokeContentSettingsSearchModeChange };
};
